<!-- eslint-disable no-unused-vars -->
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'
import RestEditableTable from '@/components/RestEditableTable'
import { GET_DEVICE_CODE } from '@/services/api/master/tracking'
import { getToolsClient } from '@/services/tools'
import moment from 'moment'
import McButton from '@/components/McButton'
import { Helper } from '@/mixin/helper'

const toolsAxios = getToolsClient()

export default {
  page: {
    title: 'SMS Gateway',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    McButton,
    PageHeader,
    Multiselect,
    RestEditableTable,
  },
  apollo: {
    deviceTypes: {
      query: GET_DEVICE_CODE,
    },
  },
  mixins: [Helper],
  data() {
    return {
      filters: {
        device: '',
        activeOn: '',
      },
      deviceTypes: {
        deviceType: [],
      },
      companies: {
        companies: [],
      },
      selectedDevices: [],
      checkedImeis: [],
      message: '',
      debounceTimer: null,
      isTabDevice: true,
      tabItemInput: {
        key: 'device',
        device: [],
        imei: '',
        phone_no: '',
      },
      isLoadingTable: false,
      isRepeatedProcess: false,
      isAllSuccessfull: null,
      statusLists: {
        true: 'Terkirim',
        unregistered: 'Tidak Terdaftar',
        failed: 'Gagal',
        loading: 'loading',
      },
      lastPong: moment(),
      isWsConnected: false,
      showStatus: false,
      pongInterval: null,
      forceDisconnect: null,
      tempCheckedDevices: [],
      intervalBroadcast: null,
    }
  },
  watch: {
    'filters.device'(newVal, oldVal) {
      if (!newVal || !oldVal) return
      this.checkedImeis = []
      this.$refs['modalFilterDeviceRef'].selectedAll = false
      this.$refs['modalFilterDeviceRef'].selectedIds = []
      this.$refs['modalFilterDeviceRef'].selectedIdsLength = 0
    },
    'tabItemInput.key'(newVal, oldVal) {
      if (!newVal || !oldVal) return
      if (oldVal !== 'device') this.tabItemInput[oldVal] = ''
      if (newVal !== 'device') return
      this.$refs['modalFilterDeviceRef'].selectedAll = false
      this.$refs['modalFilterDeviceRef'].selectedIds = []
      this.$refs['modalFilterDeviceRef'].selectedIdsLength = 0
    },
  },
  computed: {
    title() {
      return 'SMS Gateway'
    },
    fields() {
      return [
        {
          key: 'imei',
          thClass: 'mc-table--170',
          label: 'IMEI',
          type: 'text',
        },
        {
          key: 'phoneNo',
          thClass: 'mc-table--170',
          label: 'No Simcard',
          type: 'text',
        },
        {
          key: 'deviceType',
          thClass: 'mc-table--170',
          label: this.$t('setting.form.deviceType'),
          type: 'text',
          trackBy: 'deviceName',
          customLabelFn: (item, key = 'deviceType') => `${item[key].deviceName}`,
        },
        {
          key: 'assignAt',
          thClass: 'mc-table--170',
          label: this.$t('qcdevice.smsGateway.activeOn'),
          type: 'text',
        },
        {
          key: 'status',
          thClass: 'mc-table--170',
          label: 'Status',
          type: 'text',
        },
      ]
    },
    apiClient() {
      return {
        get: this.queries.get,
      }
    },
    queries() {
      return {
        get: async (param) => {
          let payload = {}
          if (this.isTabDevice) {
            let filters = `deviceName:like:${param.deviceName ?? ''}`
            if (param.activeOn) {
              const endDate = new Date(param.activeOn[1])
              endDate.setDate(endDate.getDate() + 1)
              const year = endDate.getFullYear()
              const month = String(endDate.getMonth() + 1).padStart(2, '0')
              const day = String(endDate.getDate()).padStart(2, '0')
              const resultDate = `${year}-${month}-${day}`
              filters = `${filters};activeOn:gte:${param.activeOn[0]};activeOn:lt:${resultDate}`
            }
            payload = {
              filters: filters,
              page: param.page ?? 1,
              size: param.size ?? 10,
              sorts: param.sorts ?? 'activeOn:asc',
            }
          }
          if (this.tabItemInput.key && this.tabItemInput.key !== 'device')
            payload.filters = `${this.tabItemInput.key}:eq:${param.q ?? ''}`

          if (Object.keys(payload)?.length === 0) return
          const response = await toolsAxios.get('/device', { params: payload })
          response.data.data?.forEach((val) => {
            val['can_delete'] = true
            val['activeOn'] = val.activeOn ?? '-'
            val['phoneNo'] = val.phoneNo ?? '-'
            val['assignAt'] = Helper.methods.formatDate(val.assignAt)
          })
          return response?.data
        },
      }
    },
  },
  async beforeRouteLeave(to, from, next) {
    const confirm = window.confirm(this.$t('qcdevice.bulkOnlineCommand.leaveSiteMessage'))
    if (confirm) {
      next()
    } else {
      window.onbeforeunload = function () {
        return this.$t('qcdevice.bulkOnlineCommand.leaveSiteMessage')
      }
      next(false)
    }
  },
  async created() {
    await this.$nextTick()
    this.loading = false

    this.pongInterval = setInterval(() => {
      let diff = moment().diff(this.lastPong, 'seconds')
      if (this.$socket !== undefined) {
        if (diff > 10 && this.$socket.readyState < 2) {
          this.$socket.close()
        }
      }
    }, 4000)
  },
  async mounted() {
    const payload = await toolsAxios.post('/encrypt/jwt', {
      payload: {
        tags: ['response-sms'],
      },
    })
    localStorage.setItem('payload', payload?.data)
    await this.startWebSocket()
  },
  beforeDestroy() {
    this.forceDisconnect = true
    clearInterval(this.intervalBroadcast)
  },

  async destroyed() {
    await this.$store.dispatch('ws/WSDisconnect')
    clearInterval(this.pongInterval)
  },
  methods: {
    async startWebSocket() {
      const obj = {
        type: 'update_tags',
        data: localStorage.getItem('payload'),
      }
      await this.$store.dispatch(
        'ws/WSConnect',
        `${process.env.VUE_APP_WS_URL}/ws?token=${localStorage.getItem('wsToken')}`
      )
      this.$socket.onopen = () => {
        this.$socket.sendObj(obj)
      }

      this.$socket.onmessage = (data) => {
        const signal = JSON.parse(data.data)
        if (signal.type === 'PONG') {
          this.$socket.sendObj(obj)
          this.lastPong = moment()
          this.isWsConnected = true
          return
        }

        if (signal.type === 'response-sms') {
          clearInterval(this.intervalBroadcast)
          this.reset()
          const responseBroadcast = this.selectedDevices.find(
            (val) => val.imei === signal.payload.imei || val.phoneNo === signal.payload.nomor
          )
          if (!responseBroadcast) return
          responseBroadcast.statusSendCommand =
            this.statusLists[`${signal.payload.status ? 'true' : 'failed'}`]
          return
        }
      }

      this.$socket.onclose = async () => {
        this.isWsConnected = false
        if (this.forceDisconnect) return
      }
    },
    async checkConnection() {
      await this.startWebSocket()
      this.showStatus = true
    },
    handleInputBulkEdit() {
      if (this.selectedDevices.some((e) => e.statusSendCommand === 'loading')) return
      this.$bvModal.show('smsGatewayModal')
      this.isLoadingTable = true
      if (!this.isAllSuccessfull) return
      this.isRepeatedProcess = true
      const tempCheckedDevices = this.selectedDevices ?? []
      this.tempCheckedDevices = tempCheckedDevices
      this.selectedDevices = this.selectedDevices.map((obj) => {
        let newObj = { ...obj }
        newObj.statusSendCommand = '-'
        return newObj
      })
      this.filters = {}
      this.$refs['modalFilterDeviceRef'].items = []
      this.$refs['modalFilterDeviceRef'].selectedIds = {}
      this.$refs['modalFilterDeviceRef'].selectedIdsLength = 0
      this.$refs['modalFilterDeviceRef'].selectedAll = false
      this.$refs['modalFilterDeviceRef'].totalCount = 0
      this.$refs['modalFilterDeviceRef'].page = 1
    },
    async processMessage(event = {}, payloads) {
      let imeiData = payloads ?? this.selectedDevices
      if (!this.isWsConnected) {
        this.$toast.error('Websocket belum terhubung. Silahkan cek koneksi!')
        return
      }
      const fetchPromise = imeiData?.map(async (data, idx) => {
        try {
          if (!data) return
          const payload = {
            namespace: this.$store.state.identity.whoami.companyId.toString(),
            listener: 'request-sms',
            payload: {
              command: this.message,
              nomor: data.phoneNo,
              imei: data.imei,
            },
          }
          this.getStatusBroadcast(idx, data, this.statusLists.loading)
          if (!data.phoneNo || data.phoneNo === '' || data.phoneNo === '-') {
            this.getStatusBroadcast(idx, data, this.statusLists.failed)
            return
          }
          const result = await this.sendBroadcast(payload)
          payload.namespace = process.env.VUE_APP_WS_NAMESPACE
          await this.sendBroadcast(payload)

          if (result?.status === 'failed') {
            this.getStatusBroadcast(idx, data, this.statusLists.failed)
          }
          return result
        } catch (error) {
          this.getStatusBroadcast(idx, data, this.statusLists.failed)
          console.error(error)
        }
      })

      await Promise.all(fetchPromise)
      if (this.selectedDevices.some((e) => e.statusSendCommand === 'loading')) {
        clearInterval(this.intervalBroadcast)
        this.intervalBroadcast = setInterval(() => {
          this.processMessage().catch((error) => console.error(error))
        }, 60000)
      }

      if (this.selectedDevices.every((e) => e.statusSendCommand === 'Gagal')) this.reset()
    },

    getStatusBroadcast(idx, data, statusList) {
      this.selectedDevices.splice(idx, 1, {
        ...data,
        statusSendCommand: statusList,
      })
    },

    reset() {
      this.filters = {}
      this.message = ''
      this.tabItemInput = {}
      this.isAllSuccessfull = true
      this.isRepeatedProcess = false
      this.tempCheckedDevices = []
    },

    async sendBroadcast(payload) {
      try {
        let res = await toolsAxios({
          method: 'POST',
          url: '/websocket/broadcast',
          data: payload,
        })
        return res
      } catch (error) {
        console.log(error)
        return { status: 'failed' }
      }
    },

    async handleOk() {
      this.$bvModal.hide('smsGatewayModal')
      this.selectedDevices = this.tabItemInput.device ?? this.selectedDevices
      this.isLoadingTable = false
      if (this.isTabDevice) return
      const customInput = this.tabItemInput?.imei || this.tabItemInput?.phone_no

      const imeis = [
        ...new Set(
          customInput
            .split(',')
            .map((item) => item.trim())
            .filter((item) => item !== '')
        ),
      ]

      /*get the most updated list of imei (s)*/
      if (this.selectedDevices?.length > 0)
        this.selectedDevices = this.selectedDevices.filter((item) =>
          imeis.includes(item[`${this.tabItemInput.key}`])
        )
      this.getDataForMainTable(imeis)
    },

    async getDataForMainTable(imeis) {
      if (!imeis) return
      const selectedDevices = imeis?.map(async (val) => {
        try {
          this.isLoadingTable = true
          const response = await this.queries.get({ q: val, key: this.tabItemInput.key })
          let [data] = response.data.length > 0 ? response.data : []
          let keyColumn = 'imei'
          if (response.data.length === 0) {
            if (this.tabItemInput.key === 'phone_no') keyColumn = 'phoneNo'
            data = {}
            data[`${keyColumn}`] = val
            data['deviceType'] = '-'
            data['statusSendCommand'] = this.statusLists.unregistered
          } else {
            data['deviceType'] = data.deviceType?.deviceName
            data['statusSendCommand'] = '-'
          }
          if (!this.selectedDevices?.find((e) => e[`${keyColumn}`] === data[`${keyColumn}`]))
            this.selectedDevices?.push(data)
        } catch (error) {
          console.log(error)
        }
      })
      await Promise.all(selectedDevices)
      this.isLoadingTable = false
    },

    cancelModal() {
      this.$bvModal.hide('smsGatewayModal')
      this.tabItemInput = {}
      this.isLoadingTable = false
    },

    customLabelDevice(item) {
      if (item.deviceName) return `${item.deviceName}`
    },
    async handleCheckedItems(item) {
      this.checkedImeis = Object.keys(item).filter((key) => item[key] === true)
      const displayedDevices = this.$refs['modalFilterDeviceRef']?.items
      const checkedDevices = displayedDevices.filter((e) => this.checkedImeis.includes(e.imei))
      checkedDevices.forEach((e) => (e['statusSendCommand'] = '-'))
      this.tempCheckedDevices = [
        ...new Map(
          [...this.tempCheckedDevices, ...checkedDevices].map((obj) => [obj.id, obj])
        ).values(),
      ]
      this.tabItemInput.device = this.tempCheckedDevices
      this.isLoadingTable = false
    },
    clearAll() {
      this.selectedDevices = []
      this.tabItemInput.imei = ''
      this.tabItemInput.phone_no = ''
    },
  },
}
</script>
<style lang="scss">
.mc-editable-table .row.justify-content-end {
  display: block;
}
.float-end.mc-ws__connection .mc-fa.icon-fill_checkmark:before {
  color: $green;
}
.multiselect__tags {
  border: 1px solid #99a1b1 !important;
  color: #344264 !important;
  font-family: 'Gotham Pro', sans-serif;
  font-size: 12px;
}
.multiselect__placeholder {
  color: #9da5b4 !important;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" />
    <p class="mb-4">{{ $t('qcdevice.smsGateway.description') }}</p>
    <div class="clearfix mc-btn-group__list">
      <div class="float-end mc-ws__connection">
        <span v-if="showStatus" :class="isWsConnected ? 'text-success' : 'text-danger'">
          {{ isWsConnected ? 'Terhubung' : 'Tidak Terhubung' }}
          <i v-if="isWsConnected" class="mc-fa icon-fill_checkmark"></i>
        </span>
        <b-button
          variant="outline-primary"
          menu-class="dropdown-menu-end"
          class="ms-3"
          @click="checkConnection"
        >
          <i class="mc-fa icon-fill_wifi"></i> {{ $t('qcdevice.smsGateway.checkConnection') }}
        </b-button>
      </div>
    </div>

    <div class="d-flex gap-2 justify-content-end mb-3">
      <McButton
        v-if="isAllSuccessfull"
        variant="secondary"
        :disabled="selectedDevices.some((e) => e.statusSendCommand === 'loading')"
        id="mc-add-btn"
        text="Ubah Command"
        icon="icon-outline_edit"
        @click="() => (this.isRepeatedProcess = true)"
      />
      <McButton
        variant="primary"
        :disabled="
          selectedDevices?.length === 0 ||
          message === '' ||
          this.selectedDevices.some((e) => e.statusSendCommand === 'loading')
        "
        id="mc-add-btn"
        text="Kirim"
        icon="bx bx-navigation"
        iconPosition="right"
        @click="processMessage"
      />
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row align-items-baseline mb-4">
          <div class="col-1">
            <label class="align-self-center fw-bold"
              >Pesan <span class="text-danger">*</span></label
            >
          </div>
          <FormulateInput
            type="text"
            v-model="message"
            placeholder="Masukkan pesan"
            validation="required"
            :validation-messages="{
              required: `Wajib Diisi`,
            }"
            validation-behavior="submit"
            error-behavior="submit"
            class="col-4 me-4"
            :disabled="
              (isAllSuccessfull && !isRepeatedProcess) ||
              selectedDevices.some((e) => e.statusSendCommand === 'loading')
            "
          />
        </div>
        <div class="ml-auto d-flex justify-content-between">
          <label class="fw-bold p-0 align-self-end">Daftar Device</label>
          <McButton
            variant="primary"
            id="mc-add-btn"
            text="Tambah"
            icon="icon-fill_plus"
            @click="handleInputBulkEdit"
          />
        </div>

        <div class="table-responsive my-3 border border-1 mc-table-overflow">
          <b-table
            ref="mainSmsTableRef"
            :items="selectedDevices"
            :fields="fields.filter((e) => e.key !== 'activeOn')"
            show-empty
            :empty-text="$t('global.emptyTable')"
            :busy="isLoadingTable"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(status)="data">
              <div class="text-danger my-2" v-if="data.item.statusSendCommand === 'loading'">
                <b-spinner class="align-middle"></b-spinner>
              </div>
              <div v-else>
                {{ data.item.statusSendCommand }}
              </div>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                {{ $t('show') }}&nbsp;<strong>{{ selectedDevices.length > 0 ? 1 : 0 }}</strong>
                &nbsp;{{ $t('to') }}&nbsp;<strong>{{ selectedDevices.length }}</strong> &nbsp;{{
                  $t('from')
                }}&nbsp;<strong>{{ selectedDevices.length }}</strong
                >&nbsp;{{ $t('entry') }}.
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  :value="1"
                  :total-rows="selectedDevices.length"
                  :per-page="selectedDevices.length"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      header-bg-variant="primary"
      modal-class="mc-sms-gateway__filter"
      id="smsGatewayModal"
      title="Input Nomer Simcard"
      size="lg"
      centered
      scrollable
      static
      no-close-on-esc
      no-close-on-backdrop
      @close="cancelModal"
    >
      <b-card class="mb-n2">
        <b-tabs>
          <b-tab
            title="Filter by Device"
            active
            @click="() => ((isTabDevice = true), (tabItemInput.key = 'device'))"
          >
            <div class="mc-report__filter-wrapper">
              <b-row class="pt-2">
                <b-form-group label="Tipe Perangkat" class="col-6">
                  <multiselect
                    ref="deviceTypeRef"
                    v-model="filters.device"
                    :options="deviceTypes.deviceType"
                    label="deviceName"
                    placeholder="Tipe Perangkat"
                    :allow-empty="true"
                    :custom-label="customLabelDevice"
                  ></multiselect>
                </b-form-group>
                <b-form-group :label="$t('qcdevice.smsGateway.activeOn')" class="col-6">
                  <FormulateInput
                    type="date-picker"
                    v-model="filters.activeOn"
                    range-separator=" - "
                    range
                    format="DD MMM YYYY"
                    value-type="YYYY-MM-DD"
                    class="p-0"
                  />
                </b-form-group>
              </b-row>
              <RestEditableTable
                ref="modalFilterDeviceRef"
                :fields="fields.filter((e) => e.key !== 'status')"
                trackBy="imei"
                :enableAddButton="false"
                :apiClient="queries"
                :customFilters="{
                  deviceName: filters?.device?.deviceName,
                  activeOn: filters?.activeOn,
                }"
                @selectedIdsChange="handleCheckedItems"
                :showNoData="true"
                :enableDeleteButton="false"
                :enableCheckbox="true"
              >
              </RestEditableTable>
            </div>
          </b-tab>
          <b-tab
            title="Input IMEI"
            @click="() => ((isTabDevice = false), (tabItemInput.key = 'imei'))"
          >
            <div class="mc-report__filter-wrapper">
              <b-row class="py-2 mb-2">
                <b-form-group>
                  <b-form-textarea
                    v-model="tabItemInput.imei"
                    placeholder="Ketik IMEI"
                    rows="15"
                    class="mt-2"
                  ></b-form-textarea>
                </b-form-group>
                <div class="d-flex justify-content-start gap-2">
                  <i class="icon-outline_info float-end pt-2"></i>
                  <h6 class="pt-2 text-muted">
                    Gunakan separator koma (,) untuk input IMEI lebih dari 1
                  </h6>
                </div>
              </b-row>
            </div>
          </b-tab>
          <b-tab
            title="Input Nomor"
            @click="() => ((isTabDevice = false), (tabItemInput.key = 'phone_no'))"
          >
            <div class="mc-report__filter-wrapper">
              <b-row class="py-2 mb-2">
                <b-form-group>
                  <b-form-textarea
                    v-model="tabItemInput.phone_no"
                    placeholder="Ketik nomor"
                    rows="15"
                    class="mt-2"
                  ></b-form-textarea>
                </b-form-group>
                <div class="d-flex justify-content-start gap-2">
                  <i class="icon-outline_info float-end pt-2"></i>
                  <h6 class="pt-2 text-muted">
                    Gunakan separator koma (,) untuk input nomor simcard lebih dari 1
                  </h6>
                </div>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
      <template #modal-footer="{ cancel }">
        <div class="d-flex justify-content-end mx-4">
          <b-button variant="outline-primary" @click="cancelModal()" class="me-3"> Batal </b-button>
          <b-button variant="primary" @click="handleOk"> Simpan </b-button>
        </div>
      </template>
    </b-modal>
  </Layout>
</template>
